import apiService from '@/services/apiService';

const actions = {
  getDonasis({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('marketing/donation')
        .then((response) => {
          commit('getDonasis', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getDonasi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/donation/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getDonasi', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getDonasi2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/donation/find-with-paging', payload)
        .then((response) => {
          commit('getDonasi2', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postDonasi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/donation', payload)
        .then((response) => {
          commit('postDonasi', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDonasis({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/donation/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putDonasi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/donation/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putDonasi', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderDonasi({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/donation/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delDonasi({ commit }, payload) {
    apiService.delete(`marketing/donation/${payload}`)
      .then((response) => {
        commit('delDonasi', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
